import './supOffers.css';
import { useNavigate, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import ReactLoading from 'react-loading';
import Dialog from '../../components/dialogModal/dialogModal';
import EmptyPage from '../../components/empty-page/emptyPage';
import Pagination from '../../components/pagination/Pagination';
import { editOffersSubmit, fetchOffers, offersCount } from './offersFun/offersCrud';

const OffersList = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [offset, setOffset] = useState(0);
    const [offersData, setOffersData] = useState([]);
    const [pageNumber, setPageNumber] = useState(1);
    const [deleteModal, setDeleteModal] = useState(false);
    const [rowData, setRowData] = useState({});
    const [load, setLoad] = useState(false);
    const [totalCount, setTotalCount] = useState(0);
    const [status, setStatus] = useState(false);
    const limit = 10;
    const { mode } = useParams();

    const refresh = () => {
        setLoad(!load);
    };

    const totalData = totalCount;
    const tableHeader = ['Name', 'Code', 'Percentage', 'Min', 'Min People', 'Limit', 'People', 'Active', 'Action'];

    useEffect(() => {
        offersCount(setTotalCount, status, setLoading);
        //eslint-disable-next-line
    }, []);

    useEffect(() => {
        fetchOffers(setLoading, setOffersData, status, limit, offset);
        //eslint-disable-next-line
    }, [limit, offset, load, status]);

    const paginationClick = (number, offSetNumber) => {
        if (Math.ceil(totalData / limit) > 1) {
            setPageNumber(+number);
            setOffset(+offSetNumber);
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        }
    };

    const handleActivateDeactivate = async () => {
        const { claimedBy, createdBy, lastEditedBy, createdAt, updatedAt, ...data } = rowData;
        const deactivatedData = { ...data, expiry: status === 'false' ? true : false };
        const res = await editOffersSubmit(rowData._id, deactivatedData, setLoading);
        if (res === 200) {
            setDeleteModal(false);
            refresh();
        }
    };

    return (
        <>
            {loading && (
                <div className='loadingBackground'>
                    <ReactLoading type='spin' color='#006aff' className='loadingSpin' />
                </div>
            )}
            <div className='supFilter offersBtnCont'>
                <h1 className='supportHeader'>Offers</h1>
                <div>
                    <select
                        name='type'
                        id='type'
                        className='select'
                        value={status}
                        onChange={(e) => setStatus(e.target.value)}
                        style={{ marginRight: '8px' }}
                    >
                        <option value={false}>Active</option>
                        <option value={true}>Expired</option>
                    </select>
                    <button className='blueBtn' onClick={() => navigate(`/support/${mode}/offers/upload`)}>
                        Add Offer
                    </button>
                </div>
            </div>
            <div className='supDropdwonContainer'>
                {offersData?.length === 0 && !loading ? (
                    <EmptyPage />
                ) : (
                    <div className='tableContainer'>
                        <table className='table'>
                            <thead className='tableHead'>
                                <tr>
                                    {tableHeader.map((head, headIndex) => {
                                        return <th key={headIndex}>{head}</th>;
                                    })}
                                </tr>
                            </thead>
                            <tbody>
                                {offersData?.map((row, rowIndex) => {
                                    return (
                                        <tr key={rowIndex} className='tableBodyRow'>
                                            <td>{row?.name ?? 'N/A'}</td>
                                            <td>{row?.code ?? 'N/A'}</td>
                                            <td>{row?.percentage ?? 'N/A'}</td>
                                            <td>{row?.min ?? 'N/A'}</td>
                                            <td>{row?.minPeople ?? 'N/A'}</td>
                                            <td>{row?.limit ?? 'N/A'}</td>
                                            <td>{row?.people ?? 'N/A'}</td>
                                            <td>{row.expiry === false ? 'Yes' : 'No'}</td>
                                            <td>
                                                <button
                                                    className='actBtn payoutBtn noWidth'
                                                    onClick={() =>
                                                        navigate(`/support/${mode}/offers/upload`, { state: row })
                                                    }
                                                >
                                                    Edit
                                                </button>
                                                <button
                                                    className='actBtn billBtn noWidth'
                                                    onClick={() => {
                                                        setRowData(row);
                                                        setDeleteModal(true);
                                                    }}
                                                >
                                                    {status === 'false' || status === false ? 'Deactivate' : 'Activate'}
                                                </button>
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                        <div className='responsiveCardContainer'>
                            {offersData?.map((row, rowIndex) => (
                                <div key={rowIndex} className='responsiveCard'>
                                    <div className='cardContent'>
                                        <p>
                                            <strong>{tableHeader[0]}:</strong> {row?.name ?? 'N/A'}
                                        </p>
                                        <p className='bookingCardLabelDisplay'>
                                            <strong>{tableHeader[1]}:</strong> {row?.code ?? 'N/A'}
                                        </p>
                                        <p>
                                            <strong>{tableHeader[2]}:</strong> {row?.percentage ?? 'N/A'}
                                        </p>
                                        <p>
                                            <strong>{tableHeader[3]}:</strong> {row?.min ?? 'N/A'}
                                        </p>
                                        <p>
                                            <strong>{tableHeader[4]}:</strong> {row?.minPeople ?? 'N/A'}
                                        </p>
                                        <p>
                                            <strong>{tableHeader[5]}:</strong> {row?.limit ?? 'N/A'}
                                        </p>
                                        <p>
                                            <strong>{tableHeader[6]}:</strong> {row?.people ?? 'N/A'}
                                        </p>
                                        <p>
                                            <strong>{tableHeader[6]}:</strong> {row.expiry === false ? 'Yes' : 'No'}
                                        </p>
                                        <div className='sendMessageBtn'>
                                            <button
                                                className='actBtn payoutBtn noWidth'
                                                onClick={() =>
                                                    navigate(`/support/${mode}/offers/upload`, { state: row })
                                                }
                                            >
                                                Edit
                                            </button>
                                            <button
                                                className='actBtn billBtn noWidth'
                                                onClick={() => {
                                                    setRowData(row);
                                                    setDeleteModal(true);
                                                }}
                                            >
                                                {status === 'false' || status === false ? 'Deactivate' : 'Activate'}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                )}
                <Pagination
                    paginationClick={paginationClick}
                    numberOfRows={totalData}
                    offSet={offset}
                    pageNumber={pageNumber}
                    limit={limit}
                />
                {deleteModal && (
                    <Dialog openModal={deleteModal} heading={'Deactivate Confirmation!'}>
                        <div className='dialogContent'>
                            <p className='confirmationText'>Are you sure?</p>
                            <p className='confirmationMessage'>
                                You want to {status === 'false' ? 'deactivate' : 'activate'} this Offer.
                            </p>
                            <div className='alignCenter'>
                                <button className='dialogActBtn submit' onClick={handleActivateDeactivate}>
                                    Yes
                                </button>
                                <button
                                    className='dialogActBtn cancel'
                                    onClick={() => {
                                        setDeleteModal(false);
                                        setRowData({});
                                    }}
                                >
                                    No
                                </button>
                            </div>
                        </div>
                    </Dialog>
                )}
            </div>
        </>
    );
};

export default OffersList;
